export const PRESET_TESTS = [
  "Alpaca", "MIST (Middle Infant Screening Test)",
  "Drumcondra Reading", "Drumcondra Maths", "BAS Reading Test",
  "WCPM (Words Correct Per Minute)", "Reading Accuracy (%)",
];

const PM_BANDS = [
  ["Magenta", [1, 2]], ["Red", [3, 4, 5]], ["Yellow", [6, 7, 8]], ["Blue", [9, 10, 11]],
  ["Green", [12, 13, 14]], ["Orange", [15, 16]], ["Turquoise", [17, 18]], ["Purple", [19, 20]],
  ["Gold", [21, 22]], ["Silver", [23, 24]], ["Emerald", [25, 26]], ["Ruby", [27, 28]], ["Sapphire", [29, 30]],
];
const PM_LEVELS = PM_BANDS.flatMap(([colour, nums]) => nums.map((n) => `${n} – ${colour}`));

export const FIELDS = [
  ["raw_score", "Raw / Value"],
  ["standard_score", "Standard Score"],
  ["sten", "STen"],
  ["percentile", "Percentile"],
];

// Test-specific score fields. subscores: [{label, max?}]
export const TEST_CONFIGS = {
  "Alpaca": {
    window: ["Start of Year", "Mid Year", "End of Year"],
    riskBands: ["At risk", "Some risk", "Low risk"],
    subscores: [
      { label: "Rhyming" }, { label: "Initial Phoneme" }, { label: "Final Phoneme" },
      { label: "Phoneme Blending" }, { label: "Phoneme Segmentation" }, { label: "Phoneme Deletion" },
      { label: "Letter Name Knowledge" }, { label: "Letter Sound Knowledge" },
      { label: "Word Recognition" }, { label: "Non-Word Recognition" },
    ],
  },
  "MIST (Middle Infant Screening Test)": {
    subscores: [
      { label: "Listening Skills", max: 15 },
      { label: "Letter Sounds", max: 26 },
      { label: "Three-Phoneme Words", max: 30 },
      { label: "Sentence Dictation", max: 36 },
    ],
    showTotal: true,
  },
  "BAS Reading Test": {
    subscores: [
      { label: "Raw Score" },
      { label: "Ability Score" },
      { label: "Reading Age", text: true },        // e.g. 6y 5m
      { label: "Reading Level (PM)", options: PM_LEVELS },
    ],
    trendField: "Ability Score",
  },
};

export const sumSubscores = (sub) =>
  Object.values(sub || {}).reduce((a, v) => { const n = parseFloat(v); return isNaN(n) ? a : a + n; }, 0);

export const numericValue = (t, cfg) => {
  if (cfg?.trendField) { const v = parseFloat(t.subscores?.[cfg.trendField]); return isNaN(v) ? null : v; }
  const subSum = sumSubscores(t.subscores);
  if (subSum > 0) return subSum;
  for (const [k] of FIELDS) { const v = parseFloat(t[k]); if (!isNaN(v)) return v; }
  return null;
};
